export default __webpack_public_path__ + "static/media/3592.9a1a9a13.png";